import React from 'react'
import './CDFsection.css'


function CDFsection () {
  return(
    <div className="Parrain-section">
      <div className="Parrain-section-title">
        <hr style={{width:'10vw'}}></hr>
        <h1> Nous Parrainons Coeur de Forêt</h1>
        <hr style={{width:'10vw'}}></hr>
      </div>
      <div className="Parrain-section-cdf">
        <div className="Parrain-container-cdf">
        <h4><p>Cœur de Forêt est une association de préservation des forêts en France et à l'international, qui agit depuis 2005 sur 
            les causes de la déforestation et de la dégradation des forêts.</p>
            <p>En France, l'association intervient depuis 2017 pour proposer des alternatives à la dégradation des forêts ainsi que pour rendre acteurs les citoyens et propriétaires de petites forêts de la préservation des forêts.</p>
            <p>Depuis 2005, Cœur de Forêt a planté plus de 2,5 millions d'arbres de 250 espèces différentes.</p>
            <p>Grâce à l'édition 2022 de l'événement, l'association a planté 106 arbres. </p>
        </h4>
        <h3>Participer à l'événement, c'est aider Coeur de Forêt à planter de nouveaux arbres ! </h3>
      </div>  
      </div>
    </div>
  )
}

export default CDFsection
